export const types = {
  CERBERUS_GET_INFO: "CERBERUS_GET_INFO",
  CERBERUS_SET_INFO: "CERBERUS_SET_INFO",
  CERBERUS_GET_SUMMARY_INFO: "CERBERUS_GET_SUMMARY_INFO",
  CERBERUS_SET_SUMMARY_INFO: "CERBERUS_SET_SUMMARY_INFO",
  CHANGE_SELECTED_MONTH: "CHANGE_SELECTED_MONTH",
  PHONE_CALLS_IDENTIFIER_SWICTH_STATE_BEGIN: "PHONE_CALLS_IDENTIFIER_SWICTH_STATE_BEGIN",
  PHONE_CALLS_IDENTIFIER_SWICTH_STATE_SUCCESS: "PHONE_CALLS_IDENTIFIER_SWICTH_STATE_SUCCESS",
  SPAM_CALLS_BLOCKING_SWICTH_STATE_BEGIN: "SPAM_CALLS_BLOCKING_SWICTH_STATE_BEGIN",
  SPAM_CALLS_BLOCKING_SWICTH_STATE_SUCCESS: "SPAM_CALLS_BLOCKING_SWICTH_STATE_SUCCESS",
  FRAUDULENT_SMS_BLOCKING_SWICTH_STATE_BEGIN: "FRAUDULENT_SMS_BLOCKING_SWICTH_STATE_BEGIN",
  FRAUDULENT_SMS_BLOCKING_SWICTH_STATE_SUCCESS: "FRAUDULENT_SMS_BLOCKING_SWICTH_STATE_SUCCESS",
  RESET: "RESET",
};

export const initialState = {
  info: null,
  infoFetching: null,
  infoError: null,
  summaryInfo: null,
  summaryInfoFetching: null,
  summaryInfoError: null,
  report: null,
  phoneCallsIdentifier: null,
  phoneCallsIdentifierFetching: null,
  phoneCallsIdentifierError: null,
  spamCallsBlocking: null,
  spamCallsBlockingFetching: null,
  spamCallsBlockingError: null,
  fraudulentSMSBlocking: null,
  fraudulentSMSBlockingFetching: null,
  fraudulentSMSBlockingError: null,
};

export const actions = {
  getCerberusInfo: () => ({
    type: types.CERBERUS_GET_INFO,
  }),
  setCerberusInfo: (data) => ({
    type: types.CERBERUS_SET_INFO,
    payload: data,
  }),
  getCerberusSummaryInfo: (data) => ({
    type: types.CERBERUS_GET_SUMMARY_INFO,
    data
  }),
  setCerberusSummaryInfo: (data) => ({
    type: types.CERBERUS_SET_SUMMARY_INFO,
    payload: data,
  }),
  changeSelectedMonth: (id) => ({
    type: types.CHANGE_SELECTED_MONTH,
    payload: id,
  }),
  phoneCallsIdentifierSwitchState: (targetActiveState, affectsSpam) => ({
    type: types.PHONE_CALLS_IDENTIFIER_SWICTH_STATE_BEGIN,
    targetActiveState,
    affectsSpam
  }),
  phoneCallsIdentifierSwitchStateSuccess: (data) => ({
    type: types.PHONE_CALLS_IDENTIFIER_SWICTH_STATE_SUCCESS,
    payload: data,
  }),
  spamCallsBlockingSwitchState: (targetActiveState, affectsPhoneCalls) => ({
    type: types.SPAM_CALLS_BLOCKING_SWICTH_STATE_BEGIN,
    targetActiveState,
    affectsPhoneCalls
  }),
  spamCallsBlockingSwitchStateSuccess: (data) => ({
    type: types.SPAM_CALLS_BLOCKING_SWICTH_STATE_SUCCESS,
    payload: data,
  }),
  fraudulentSMSBlockingSwitchState: (targetActiveState) => ({
    type: types.FRAUDULENT_SMS_BLOCKING_SWICTH_STATE_BEGIN,
    targetActiveState,
  }),
  fraudulentSMSBlockingSwitchStateSuccess: (data) => ({
    type: types.FRAUDULENT_SMS_BLOCKING_SWICTH_STATE_SUCCESS,
    payload: data,
  }),
  reset: () => ({
    type: types.RESET
  })
};

const Cerberus = (state = initialState, action) => {
  switch (action.type) {
    case types.CERBERUS_GET_INFO: {
      return {
        ...state,
        infoFetching: true,
        infoError: null,
        phoneCallsIdentifierError: null,
        spamCallsBlockingError: null,
        fraudulentSMSBlockingError: null,
      };
    }
    case types.CERBERUS_SET_INFO: {
      const { info, error } = action.payload;

      return {
        ...state,
        infoFetching: false,
        ...(error ? { infoError: error?.statusCode || error } : { info }),
      };
    }
    case types.CERBERUS_GET_SUMMARY_INFO: {
      return {
        ...state,
        summaryInfoFetching: true,
      };
    }
    case types.CERBERUS_SET_SUMMARY_INFO: {
      const { summaryInfo, error } = action.payload;

      return {
        ...state,
        summaryInfoFetching: false,
        ...(error ? { summaryInfoError: error?.statusCode || error } : { summaryInfo }),
      };
    }
    case types.PHONE_CALLS_IDENTIFIER_SWICTH_STATE_BEGIN: {
      return {
        ...state,
        phoneCallsIdentifierFetching: true,
        ...(action.affectsSpam && { spamCallsBlockingFetching: true }),
      };
    }
    case types.PHONE_CALLS_IDENTIFIER_SWICTH_STATE_SUCCESS: {
      const { info, error } = action.payload;

      return {
        ...state,
        phoneCallsIdentifierFetching: false,
        spamCallsBlockingFetching: false,
        phoneCallsIdentifier: !error ? true : false,
        ...(error ? { infoError: error?.statusCode || error, phoneCallsIdentifierError: error?.statusCode || error } : { info }),
      };
    }
    case types.SPAM_CALLS_BLOCKING_SWICTH_STATE_BEGIN: {
      return {
        ...state,
        spamCallsBlockingFetching: true,
        ...(action.affectsPhoneCalls && { phoneCallsIdentifierFetching: true }),
      };
    }
    case types.SPAM_CALLS_BLOCKING_SWICTH_STATE_SUCCESS: {
      const { info, error } = action.payload;

      return {
        ...state,
        spamCallsBlockingFetching: false,
        phoneCallsIdentifierFetching: false,
        spamCallsBlocking: !error ? true : false,
        ...(error ? { infoError: error?.statusCode || error, spamCallsBlockingError: error?.statusCode || error } : { info }),
      };
    }
    case types.FRAUDULENT_SMS_BLOCKING_SWICTH_STATE_BEGIN: {
      return {
        ...state,
        fraudulentSMSBlockingFetching: true,
      };
    }
    case types.FRAUDULENT_SMS_BLOCKING_SWICTH_STATE_SUCCESS: {
      const { info, error } = action.payload;

      return {
        ...state,
        fraudulentSMSBlockingFetching: false,
        fraudulentSMSBlocking: !error ? true : false,
        ...(error ? { infoError: error?.statusCode || error, fraudulentSMSBlockingError: error?.statusCode || error } : { info }),
      };
    }
    case types.CHANGE_SELECTED_MONTH: {
      const updateInfo = {
        ...state.summaryInfo,
        selectedId: action.payload,
      };

      return {
        ...state,
        summaryInfo: updateInfo,
      };
    }
    case types.RESET: {
      return {
        ...state,
        spamCallsBlocking: null,
        phoneCallsIdentifier: null,
        fraudulentSMSBlocking: null,
      }
    }
    default:
      return state;
  }
};

export default Cerberus;
